/**
 * What the dashboard's switch does with the agent's Firebase node
 * (`widget/presence-{org}/{user}`), whose contract other services read:
 *
 * - `forcedOffline: true` is the agent being Unavailable, whoever set it (the app, this switch, an
 *   administrator). It persists, and the last one to set it wins.
 * - `onlineWeb: true` is this dashboard being open with the agent present in it.
 *
 * The switch is on when `onlineWeb` is true. An open dashboard puts the agent present by itself
 * unless `forcedOffline` is set; closing it only ends that presence.
 */

/** The switch's state from a node event; no node (or no `detail`) is "not forced off". */
export function presenceOf(event) {
    const detail = event?.detail;
    return {
        available: detail?.onlineWeb === true,
        forcedOffline: detail?.forcedOffline === true,
    };
}

/**
 * Whether this dashboard switches the agent on by itself. Never before Firebase has answered
 * once (`presenceKnown`): acting on the empty default would undo an Unavailable set from the app.
 */
export function shouldSwitchOn({ role, presenceKnown, forcedOffline }) {
    return role !== 'root' && presenceKnown === true && !forcedOffline;
}
